export default __webpack_public_path__ + "static/media/frederick.42757489.jpeg";